import { render } from "./RestartVeda.vue?vue&type=template&id=17778861"
import script from "./RestartVeda.vue?vue&type=script&lang=ts"
export * from "./RestartVeda.vue?vue&type=script&lang=ts"
script.render = render

export default script